"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
function FormOptions(_a) {
    var options = _a.options, setOptions = _a.setOptions, submit = _a.submit;
    return react_1.default.createElement("div", { className: 'storybook-ecaptures-formoptions flex flex-col' },
        react_1.default.createElement(storybook_1.Forms.Field, { className: 'mb-4 flex ml-auto' },
            react_1.default.createElement(storybook_1.Texts.Small, { className: 'mr-4' }, "Actief"),
            react_1.default.createElement(storybook_1.Forms.Toggle, { value: options.ecapture, onClick: function () {
                    var value = { options: __assign(__assign({}, options), { ecapture: !options.ecapture }) };
                    submit(value).then(function () {
                        setOptions('ecapture', !options.ecapture);
                    });
                }, submit: submit })),
        react_1.default.createElement(storybook_1.Forms.Field, null,
            react_1.default.createElement(storybook_1.Forms.Textarea, { name: 'title', value: options.ecapture_title, placeholder: 'Titel voor email capture', onChange: function (ecapture_title) { return setOptions('ecapture_title', ecapture_title); } })),
        react_1.default.createElement(storybook_1.Forms.Field, null,
            react_1.default.createElement(storybook_1.Forms.Select, { name: 'category_id', value: options.ecapture_time, onChange: function (ecapture_time) { return setOptions('ecapture_time', ecapture_time); } },
                react_1.default.createElement("option", { value: 'before' }, "Toon voor de video"),
                react_1.default.createElement("option", { value: 'after' }, "Toon na de video"))),
        react_1.default.createElement(storybook_1.Forms.Field, null,
            react_1.default.createElement(storybook_1.Texts.Small, null, "Met e-mail capture kan je e-mailadressen verzamelen van fans, schrijf een korte wervende zin en stel in of de opt-in voor- of na de video getoond moet worden. Je kan deze vervolgens per video aan- of uitzetten.")));
}
exports.default = FormOptions;
